export default __webpack_public_path__ + "static/media/1-08-16-maze.a8ad5af2.m4a";